module.exports = __webpack_public_path__ + "img/zamknij_small.f5b5f02f.svg";